<docs>
## YuIcon Docs

* `:active`用 CSS 样式
* `.i-active`用 Click Event
* 支持 ID Props，忽略`yu-ico-`前缀

</docs>

<template>
  <svg
    :class="[
      'yu-icon',
      'yu-ico-' + (active ? onName : name),
      {
        'i-active': active
      }
    ]"
    data-com='YuIcon'
  ><use :xlink:href="'#yu-ico-' + (active ? onName : name)"></use></svg>
</template>

<script>
export default {
  componentName: 'YuIcon',
  props: {
    name: {
      type: String,
      default: ''
    },
    onName: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// Icon.vue?8cc7be18